export function getTotalCountPages(count: number, step: number) {
  return Math.max(Math.ceil(count / step), 1);
}
